<template lang="pug">
	modal(:max-width="1024")
		.card.text-left
			.card-header
				span.fa.fa-edit.mr-2
				| Editor de programas
				button.close(@click="cerrar") &times;
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
						.form-group
							label Emisora
							select.form-control(v-model="programa.emisora_ID")
								option(:value="null") Selecciona
								option(v-for="emisora in listadoEmisoras", :key="emisora.ID_emisora", :value="emisora.ID_emisora") {{emisora.nombre}}
						.form-group
							label Nombre
							input.form-control(v-model="programa.nombre")
						.form-group
							label Intérvalo
							.input-group
								.input-group-prepend
									.input-group-text De
								input.form-control(v-model="programa.hora_inicio", v-mask="'##:##:##'", placeholder="HH:MM:SS")
								.input-group-append
									.input-group-text a
								input.form-control(v-model="programa.hora_fin", v-mask="'##:##:##'", placeholder="HH:MM:SS")
					.col-xs-12.col-sm-12.col-md-9.col-lg-9.col-xl-9
						calendario-anual(:seleccion.sync="programa.dias", :ano="ano", :from="new Date()")
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
		selecciona-estrategia(v-if="seleccionarEstrategia", :estrategia.sync="programa.estrategia", @cerrar="seleccionarEstrategia = null", @continuar="guardar")
</template>
<script>
import axios from 'axios'
import SelectDias from '../utilidades/select-dias.vue'
import CalendarioAnual from '../utilidades/calendario-anual'
import SeleccionaEstrategia from './selecciona-estrategia'
export default {
	components: {
		'select-dias': SelectDias,
		'calendario-anual': CalendarioAnual,
		'selecciona-estrategia': SeleccionaEstrategia
	},
	data () {
		return {
			programa: {
				ID_programa: null,
				emisora_ID: null,
				nombre: '',
				hora_inicio: '',
				hora_fin: '',
				dias_semana: [],
				activo: true,
				dias: [],
				estrategia: null
			},
			diasSem: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
			ano: new Date().getFullYear(),
			listadoEmisoras: [],
			seleccionarEstrategia: null
		}
	},
	created () {
		axios.get('gestion-emisoras/php/api/emisoras/buscar-emisoras.php')
			.then(res => {
				this.listadoEmisoras = res.data.listado
			})
			.catch(this.$responseError)
	},
	methods: {
		toggleDiaSemana (dia) {
			const idx = this.programa.dias_semana.indexOf(dia)

			if (idx < 0) {
				this.programa.dias_semana.push(dia)
			} else {
				this.programa.dias_semana.splice(idx, 1)
			}
		},
		guardar () {
			axios.post('gestion-emisoras/php/api/programas/set-programa.php', this.programa)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Guardado',
						mensaje: 'Se han realizado un total de: <b>' + res.data.totalInserciones + ' inserciones</b>'
					})
					this.cerrar()
				})
				.catch(e => {
					console.log(e.response.data)
					if (e.response.data.error === 100) {
						this.seleccionarEstrategia = true
					} else {
						this.$responseError(e)
					}
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/programas/editor-programas.vue